module.exports = __webpack_public_path__ + "img/6a36a03.svg";